module.exports = __webpack_public_path__ + "static/media/mobileScreenshot06.17d237e7.jpg";